import { VulnerabilityEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(VulnerabilityEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    VulnerabilityEnds.GET_ALL(queryString),
    true,
    {},
    {},
    axios
  );

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(VulnerabilityEnds.DELETE(id), true, {}, {}, axios);

const detail = async (id: string): Promise<any> =>
  APIManager.sendGet(VulnerabilityEnds.GET_DETAIL(id), true, {}, {}, axios);

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(VulnerabilityEnds.UPDATE(id), data, true, {}, {}, axios);

const linkAISystem = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    VulnerabilityEnds.LINK_AI_SYSTEM(id),
    data,
    true,
    {},
    {},
    axios
  );

const linkDataset = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    VulnerabilityEnds.LINK_DATASET(id),
    data,
    true,
    {},
    {},
    axios
  );

const linkIncident = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    VulnerabilityEnds.LINK_INCIDENT(id),
    data,
    true,
    {},
    {},
    axios
  );

const linkRisk = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    VulnerabilityEnds.LINK_RISK(id),
    data,
    true,
    {},
    {},
    axios
  );

const getDashboard = async (): Promise<any> =>
  APIManager.sendGet(VulnerabilityEnds.DASHBOARD, true, {}, {}, axios);

const bulkUpdateStatus = async (data: any): Promise<any> =>
  APIManager.sendPut(
    VulnerabilityEnds.BULK_UPDATE_STATUS,
    data,
    true,
    {},
    {},
    axios
  );

const bulkCreate = async (data: any): Promise<any> =>
  APIManager.sendPost(VulnerabilityEnds.BULK_UPLOAD, data, true, {}, {}, axios);

export const VulnerabilityService = {
  create,
  getAll,
  detail,
  deleteRecord,
  update,
  linkAISystem,
  linkDataset,
  linkIncident,
  linkRisk,
  getDashboard,
  bulkUpdateStatus,
  bulkCreate,
};
